import { graphql } from '@/generated/gql';

export const NEGOTIATION_REMINDER_SETTINGS_MUTATION = graphql(/* GraphQL */ `
  mutation ReminderSettingsMutation($data: TsrctUpdateReminderConfigInput!) {
    tesseract {
      updateReminderConfig(data: $data) {
        reminderConfigId
        targetId
        type
        variant
        source
        reminderDelayWorkingDays
        cancellationDelayWorkingDays
        executionTime
        timezone
      }
    }
  }
`);
